import { render, staticRenderFns } from "./NeedToApplyLeaveToCrossAppeal.vue?vue&type=template&id=2d6c2b30&scoped=true"
import script from "./NeedToApplyLeaveToCrossAppeal.vue?vue&type=script&lang=ts"
export * from "./NeedToApplyLeaveToCrossAppeal.vue?vue&type=script&lang=ts"
import style0 from "./NeedToApplyLeaveToCrossAppeal.vue?vue&type=style&index=0&id=2d6c2b30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6c2b30",
  null
  
)

export default component.exports